import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { IconNames } from '@app/shared/enums/icon-names';
import { ThemeService } from '@app/core/services/theme.service';
import { Theme } from '@app/support/models/theme.model';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';

@Component({
  selector: 'app-report-error-dialog',
  templateUrl: './report-error-dialog.component.html',
  styleUrl: './report-error-dialog.component.scss',
  imports: [IceAlertComponent],
})
export class ReportErrorDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ReportErrorDialogComponent>>(MatDialogRef);
  private themeService = inject(ThemeService);

  IconNames = IconNames;
  selectedTheme$: Observable<Theme>;

  ngOnInit(): void {
    this.selectedTheme$ = this.themeService.selectedTheme;
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }
}
